import { currentB2BRoute, withB2BContext } from './b2b';
import { enqueuePulseEvent, flushPulse } from './client';
import { adoptAnonId } from './identity';
import {
  B2BActionProps,
  B2BPageLeftProps,
  B2BPageViewedProps,
  ChatStartedProps,
  FirstQuestionShownProps,
  LoginSucceededProps,
  QuestionAnsweredProps,
  ShortlistViewedProps,
  SignupCompletedProps,
  SurveyCompletedProps,
  TrialCardOpenedProps,
} from './taxonomy';

export const pulse = {
  chatStarted: (props: ChatStartedProps = {}) => enqueuePulseEvent('chat_started', props),
  firstQuestionShown: (props: FirstQuestionShownProps = {}) =>
    enqueuePulseEvent('first_question_shown', props),
  questionAnswered: (props: QuestionAnsweredProps) => enqueuePulseEvent('question_answered', props),
  surveyCompleted: (props: SurveyCompletedProps) => enqueuePulseEvent('survey_completed', props),
  signupCompleted: (props: SignupCompletedProps) => enqueuePulseEvent('signup_completed', props),
  loginSucceeded: (props: LoginSucceededProps) => enqueuePulseEvent('login_succeeded', props),
  shortlistViewed: (props: ShortlistViewedProps) => enqueuePulseEvent('shortlist_viewed', props),
  trialCardOpened: (props: TrialCardOpenedProps) => enqueuePulseEvent('trial_card_opened', props),

  // B2B events are dropped unless a non-patient user is signed in (see withB2BContext).
  b2bPageViewed: (props: B2BPageViewedProps) => {
    const event = withB2BContext(props);
    if (event) enqueuePulseEvent('b2b_page_viewed', event);
  },
  b2bPageLeft: (props: B2BPageLeftProps) => {
    const event = withB2BContext(props);
    if (event) enqueuePulseEvent('b2b_page_left', event);
  },
  // Route context defaults to the current location so call sites only name the action.
  b2bAction: (props: B2BActionProps) => {
    const event = withB2BContext({ ...currentB2BRoute(), ...props });
    if (event) enqueuePulseEvent('b2b_action', event);
  },
};

export const adoptPulseAnonId = (incoming: string): boolean => adoptAnonId(incoming);

// Flush remaining events when the page is hidden/unloaded.
let lifecycleBound = false;
export const initPulseLifecycleFlush = (): void => {
  if (lifecycleBound || typeof document === 'undefined') return;
  lifecycleBound = true;
  const flush = () => {
    flushPulse({ beacon: true }).catch(() => undefined);
  };
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);
};

export type { B2BPageTracker } from './b2bPageTracker';
export { B2B_PAGE_SETTLE_MS, createB2BPageTracker } from './b2bPageTracker';
export { flushPulse } from './client';
